// components/slides/useSlidesAuthor.ts
import { useMemo } from 'react';
import { useKernelStore } from '@/kernel/kernelStores';
import type { SlideElement } from '#types/types';

/** Who is writing, as stamped on a callout they write by hand. Null until a name is known: a placeholder
 *  stamped before the User row hydrates would stay on the callout. */
export function useSlidesAuthor(): NonNullable<SlideElement['writtenBy']> | null {
  const userId = useKernelStore(s => s.userContext.dbUserId);
  const firstName = useKernelStore(s => userId ? s.inventory.User.registry[userId]?.firstName : null);
  const lastName = useKernelStore(s => userId ? s.inventory.User.registry[userId]?.lastName : null);
  const email = useKernelStore(s => userId ? s.inventory.User.registry[userId]?.email : null);
  // The boot already carries the signed-in name, before the User registry hydrates.
  const bootName = useKernelStore(s => s.userContext.impersonatedUser?.name ?? s.userContext.trueUser?.name ?? null);
  return useMemo(() => {
    const name = [firstName, lastName].filter(Boolean).join(' ') || bootName || email;
    return userId && name ? { userId, name } : null;
  }, [userId, firstName, lastName, email, bootName]);
}
